export function organisationDisplayName(name: string | undefined): string | undefined {
  return name?.trim().toLocaleLowerCase('en-AU') === 'quality.vet' ? 'Quality VET' : name;
}
